import React from "react";
import {
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Paper,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import BreadCrumb from "../../components/BreadCrumb";

function FAQPage() {
  const faqs = [
    {
      category: "Orders & Shipping",
      items: [
        {
          question: "How do I track my order?",
          answer:
            "You can track your order by logging into your account and viewing the order status under 'My Orders'.",
        },
        {
          question: "What are the shipping costs?",
          answer:
            "Shipping costs vary based on your location and the items purchased. Free shipping is available for orders over $100.",
        },
      ],
    },
    {
      category: "Returns & Refunds",
      items: [
        {
          question: "What is your return policy?",
          answer:
            "We accept returns within 30 days of purchase. Items must be unused and in original packaging.",
        },
        {
          question: "How long do refunds take?",
          answer:
            "Refunds are typically processed within 5-7 business days after we receive your return.",
        },
      ],
    },
  ];

  const breadcrumbUrls = [
    // { path: '/previous', label: 'Back' },
    { path: '/', label: 'Home' },
    { path: '/faq', label: 'FAQ' },
  ];

  return (
    <div>
      <BreadCrumb title="Frequently Asked Questions" urls={breadcrumbUrls} />
      <Container maxWidth="lg" sx={{ marginY: 8 }}>
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2, md: 6 },
            backgroundColor: "#f5f5f5",
            borderRadius: 2,
            mb: 4,
          }}
        >
          {/* <Typography
            variant="h4"
            gutterBottom
            sx={{
              fontWeight: 600,
              color: "#1e1e1e",
              mb: 2,
              textAlign: { xs: "left", md: "center" },
            }}
          >
            Frequently Asked Questions
          </Typography> */}
          <Typography
            variant="h6"
            sx={{
              color: "#666",
              mb: 4,
              textAlign: { xs: "left", md: "center" },
            }}
          >
            Find answers to common questions about our products and services
          </Typography>
        </Paper>

        {faqs.map((category, index) => (
          <Box key={index} sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 500,
                color: "#9e6747",
                mb: 2,
              }}
            >
              {category.category}
            </Typography>

            {category.items.map((faq, faqIndex) => (
              <Accordion
                key={faqIndex}
                disableGutters
                elevation={0}
                sx={{
                  border: "1px solid #E0E0E0",
                  borderRadius: "8px !important",
                  mb: 2,
                  "&:before": { display: "none" },
                  "&:hover": {
                    borderColor: "#9e6747",
                    transition: "all 0.3s ease",
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    padding: 2,
                    "& .MuiAccordionSummary-content": {
                      margin: 0,
                    },
                  }}
                >
                  <Typography sx={{ fontWeight: 500, color: "#333" }}>
                    {faq.question}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    padding: 2,
                    backgroundColor: "#f8f9fa",
                    color: "#666",
                  }}
                >
                  <Typography>{faq.answer}</Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        ))}
      </Container>
    </div>
  );
}

export default FAQPage;
